import {useEffect} from "react";

export const useInjectTitle = (title) => {

  useEffect(() => {
    if (!title) {
      return;
    }

    const previousTitle = document.title;
    document.title = title;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default useInjectTitle;